import { useFilters } from "@/composables/filters/useFilters";

const STORE_FILTER_KEY = "readinessRolesData";

let instance = null;

/**
 * Per-Access Roles table filter persistence (ER-11193).
 * Replaces legacy Vuex `filterStore/updateFilters` so writes go through
 * Pinia + localStorageHelper (`filtersByAccess[accessId][key]`).
 */
export function useOrganizationRolesTableViewState() {
  if (instance) return instance;
  const filter = useFilters();
  instance = {
    key: STORE_FILTER_KEY,
    getFilters() {
      return filter.getFilters(STORE_FILTER_KEY);
    },
    setFilters(filters) {
      filter.setFilters({ key: STORE_FILTER_KEY, filters });
    },
  };
  return instance;
}

export function resetOrganizationRolesTableViewState() {
  instance = null;
}
